import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';
import styled from 'styled-components';

import { COLOR_BLACK, COLOR_WHITE } from '../../constants/colors';
import { fontStyles } from '../../constants/styles';
import { rangesMatch, tomorrowRange, tonightRange } from '../../helpers/quickPickDates';


const ChipRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
`;

const Chip = styled.button`
  ${fontStyles.bodySmall}
  border: 0;
  cursor: pointer;
  background-color: ${(props) => (props.isActive ? props.fg : 'transparent')};
  color: ${(props) => (props.isActive ? props.bg : props.fg)};
  padding: 0.25rem 0.5rem;
`;


const buildChips = () => {
  const now = moment();
  return [
    {
      id: 'bookDirect.quickTonight',
      defaultMessage: 'Tonight',
      range: tonightRange(now),
    },
    {
      id: 'bookDirect.quickTomorrow',
      defaultMessage: 'Tomorrow',
      range: tomorrowRange(now),
    },
  ];
};

const QuickPickChips = ({ bg, currentRange, fg, onSelect }) => {
  const chips = buildChips();
  return (
    <ChipRow>
      <For each="chip" of={chips}>
        <Chip
          key={chip.id}
          bg={bg}
          fg={fg}
          isActive={rangesMatch(currentRange, chip.range)}
          onClick={() => onSelect(chip.range)}
          type="button"
        >
          <FormattedMessage defaultMessage={chip.defaultMessage} id={chip.id} />
        </Chip>
      </For>
    </ChipRow>
  );
};

QuickPickChips.propTypes = {
  bg: PropTypes.string,
  currentRange: PropTypes.shape({
    arrivalDate: PropTypes.instanceOf(moment),
    departureDate: PropTypes.instanceOf(moment),
  }),
  fg: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
};

QuickPickChips.defaultProps = {
  bg: COLOR_WHITE,
  fg: COLOR_BLACK,
  currentRange: null,
};

export default QuickPickChips;
